class FacetWP_Filters {
	widget;
	mainAccordion;
	desktopMediaQuery;

	/**
	 * FacetWP Filters widget.
	 *
	 * @param {HTMLElement} widget The main widget element.
	 */
	constructor( widget ) {
		this.widget = widget;
		this.mainAccordion = this.widget.querySelector( ':scope > details' );
		this.desktopMediaQuery = window.matchMedia( '(min-width: 768px)' );

		/**
		 * Set viewport events
		 */
		this.setViewport(); // Set viewport on load
		this.desktopMediaQuery.addEventListener( 'change', () => this.setViewport() ); // On media query change

	}

	/**
	 * Force the main accordion open on desktop.
	 */
	setViewport() {
		this.mainAccordion.open = !!this.desktopMediaQuery.matches;
	}
}

document.querySelectorAll( '.whippet-facetwp-filters' ).forEach( widget => new FacetWP_Filters( widget ) );
